<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.licences.resume.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.licences.resume.hint' | translate }}</p>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="resume-component">
      <span class="av-meta">{{ 'backoffice.licences.filters.component' | translate }}</span>
      <select id="resume-component" class="av-field" formControlName="component_type">
        @for (component of pendingComponents; track component.component_type) {
          <option [value]="component.component_type">
            {{
              'backoffice.licences.resume.component_option'
                | translate
                  : {
                      component: component.componentLabelKey | translate,
                      count: component.pending_cancellation,
                    }
            }}
          </option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="resume-quantity">
      <span class="av-meta">{{ 'backoffice.licences.resume.quantity' | translate }}</span>
      <input
        id="resume-quantity"
        type="number"
        class="av-field"
        min="1"
        [attr.max]="quantityMax"
        formControlName="quantity"
      />
    </label>

    <label class="d-flex flex-column gap-1" for="resume-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="resume-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.licences.resume.submit' | translate }}
  </button>
</mat-dialog-actions>
